/**
 * Public receipts speak in the third person. Idempotent if the text
 * already says "they".
 */

function matchCase(source, replacement) {
  if (!source) return replacement;
  if (source === source.toUpperCase()) return replacement.toUpperCase();
  if (source[0] === source[0].toUpperCase()) {
    return replacement[0].toUpperCase() + replacement.slice(1);
  }
  return replacement;
}

export function toPublicDecisionReason(text) {
  if (!text) return "";
  return String(text)
    .replace(/\byou['’]re\b/gi, (match) => matchCase(match, "they're"))
    .replace(/\byou['’]ll\b/gi, (match) => matchCase(match, "they'll"))
    .replace(/\byour\b/gi, (match) => matchCase(match, "their"))
    .replace(/\byou\b/gi, (match) => matchCase(match, "they"));
}
